import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import ButtonBlack from "../../../../components/Buttons/ButtonBlack"
import { CgClose } from "react-icons/cg";

const StarRating = ({show =false, setShowModal}) => {
  const [isRated, setIsRated] = useState(false);
  const [rating, setRating] = useState(null);
//   const [showModal, setshowModal] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsRated(true);
  };

  const handleEdit = () => {
    setIsRated(false);
  };

  const getRatingMessage = () => {
    switch (rating) {
      case "1":
        return "Ce candidat ne m'interesse pas.";
      case "2":
        return "Ce candidat ne m'interesse pas.";
      case "3":
        return "Ce candidat m'intéresse.";
      case "4":
        return "Ce candidat m'intéresse beaucoup.";
      case "5":
        return "Ce candidat est incroyable.";
      default:
        return "";
    }
  };

  if(!show) return null;

  return (

      
<>
      <AnimatePresence>
        {/* {!isRated && ( */}
          <motion.div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className="bg-white rounded-lg shadow-lg p-6 text-center w-96"
              initial={{ y: "-100vh", opacity: 0 }}
              animate={{ y: "0", opacity: 1 }}
              exit={{ y: "100vh", opacity: 0 }}
              transition={{ type: "spring", stiffness: 60 }}
            >
                <button
        onClick={() => {
            setShowModal(false)
            // onClose()
        }
        }
        className="p-4  absolute rounded-full z-30 ml-52 -mt-10 bg-white text-primary-black hover:bg-white/80"
      >
        <CgClose></CgClose>
        
      </button> 
              <div className="flex flex-col">
                <div className="flex flex-row-reverse justify-center mb-4 space-x-2 space-x-reverse">
                  {[5, 4, 3, 2, 1].map((value) => (
                    <React.Fragment key={value}>
                      <input
                        type="radio"
                        name="rate"
                        id={`rate-${value}`}
                        value={value}
                        className="hidden peer"
                        onChange={() => setRating(value.toString())}
                      />
                      <label
                        htmlFor={`rate-${value}`}
                        className="text-5xl text-gray-400 cursor-pointer peer-hover:text-yellow-400 peer-checked:text-yellow-500 transition"
                      >
                        ★
                      </label>
                    </React.Fragment>
                  ))}
                </div>
                <div onSubmit={handleSubmit} className="w-full flex-col h-auto flex ">
                  {rating && (
                    <header className="mb-4 text-lg font-semibold text-primary-black ">
                      {getRatingMessage()}
                    </header>
                  )}
                  <textarea
                    className="w-full h-24 p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-green/40 focus:border-transparent"
                    placeholder="Laisser une note..."
                  ></textarea>
                  <ButtonBlack
                    DefaultClassName="mt-4 px-4 py-2  text-white rounded-sm hover:bg-blue-600 w-full"
                  >
                    Enregistrer
                  </ButtonBlack>
                </div>
              </div>
            </motion.div>
          </motion.div>
        {/* )} */}
      </AnimatePresence>
    </>
  );
};

export default StarRating;
